// AUTO-GENERATED — do not edit. Regenerated by Vite on build/dev start, or via `pnpm generate:theme`.
export const generatedVars = {
    thirdColor: 'var(--third-color)',
    fourthColor: 'var(--fourth-color)',
    warningColor: 'var(--warning-color)',
    attentionColor: 'var(--attention-color)',
    drainingColor: 'var(--draining-color)',
    infoColor: 'var(--info-color)',
    darkColor: 'var(--dark-color)',
    lightColor: 'var(--light-color)',
    darkGrayColor: 'var(--dark-gray-color)',
    midGrayColor: 'var(--mid-gray-color)',
    lightGrayColor: 'var(--light-gray-color)',
    favoriteColor: 'var(--favorite-color)',
    transparentDarkColor: 'var(--transparent-dark-color)',
    transparentLightColor: 'var(--transparent-light-color)',
    edekaYellow: 'var(--edeka-yellow)',
    marktkaufGreen: 'var(--marktkauf-green)',
    edekaBlue: 'var(--edeka-blue)',
    paybackBlue: 'var(--payback-blue)',
    paybackLightBlue: 'var(--payback-light-blue)',
    mainColorFilter: 'var(--main-color-filter)',
    primaryMain: 'var(--palette-primary-main)',
    primaryLight: 'var(--palette-primary-light)',
    primaryDark: 'var(--palette-primary-dark)',
    primaryContrastText: 'var(--palette-primary-contrastText)',
    secondaryMain: 'var(--palette-secondary-main)',
    secondaryLight: 'var(--palette-secondary-light)',
    secondaryDark: 'var(--palette-secondary-dark)',
    secondaryContrastText: 'var(--palette-secondary-contrastText)',
    errorMain: 'var(--palette-error-main)',
    errorLight: 'var(--palette-error-light)',
    errorContrastText: 'var(--palette-error-contrastText)',
    successMain: 'var(--palette-success-main)',
    warningMain: 'var(--palette-warning-main)',
    warningLight: 'var(--palette-warning-light)',
    warningDark: 'var(--palette-warning-dark)',
    textPrimary: 'var(--palette-text-primary)',
    textSecondary: 'var(--palette-text-secondary)',
    backgroundPaper: 'var(--palette-background-paper)',
    commonBlack: 'var(--palette-common-black)',
    commonWhite: 'var(--palette-common-white)',
    grey100: 'var(--palette-grey-100)',
    grey200: 'var(--palette-grey-200)',
    grey300: 'var(--palette-grey-300)',
    grey400: 'var(--palette-grey-400)',
    grey500: 'var(--palette-grey-500)',
    grey600: 'var(--palette-grey-600)',
    grey700: 'var(--palette-grey-700)',
    grey800: 'var(--palette-grey-800)',
    grey900: 'var(--palette-grey-900)',
    cartBackgroundMain: 'var(--palette-cartBackground-main)',
    cartBackgroundContrastText: 'var(--palette-cartBackground-contrastText)',
    discountMain: 'var(--palette-discount-main)',
    discountContrastText: 'var(--palette-discount-contrastText)',
    disruptorMain: 'var(--palette-disruptor-main)',
    disruptorContrastText: 'var(--palette-disruptor-contrastText)',
    mapNewProductMain: 'var(--palette-mapNewProduct-main)',
    mapNewProductContrastText: 'var(--palette-mapNewProduct-contrastText)',
    mapBoughtInPastMain: 'var(--palette-mapBoughtInPast-main)',
    mapBoughtInPastContrastText: 'var(--palette-mapBoughtInPast-contrastText)',
    headerBackgroundMain: 'var(--palette-headerBackground-main)',
    headerBackgroundLight: 'var(--palette-headerBackground-light)',
    headerBackgroundDark: 'var(--palette-headerBackground-dark)',
    headerBackgroundContrastText: 'var(--palette-headerBackground-contrastText)',
    animationTime: 'var(--animation-time)',
    mediumAnimationTime: 'var(--medium-animation-time)',
    slowAnimationTime: 'var(--slow-animation-time)',
    fixedRem: 'var(--fixed-rem)',
    small: 'var(--small)',
    smallRel: 'var(--small-rel)',
    medium: 'var(--medium)',
    mediumRel: 'var(--medium-rel)',
    normal: 'var(--normal)',
    headerSize: 'var(--header-size)',
    headerSizeRel: 'var(--header-size-rel)',
    bannerSize: 'var(--banner-size)',
    bannerSizeRel: 'var(--banner-size-rel)',
    smallMargin: 'var(--small-margin)',
    margin: 'var(--margin)',
    bigMargin: 'var(--big-margin)',
    largeMargin: 'var(--large-margin)',
    touchSize: 'var(--touch-size)',
    gridMaxWidth: 'var(--grid-max-width)',
    borderRadius: 'var(--border-radius)',
    cappedBorderRadius: 'var(--capped-border-radius)',
    concentricRadiusOuterSm: 'var(--concentric-radius-outer-sm)',
    concentricRadiusOuterMd: 'var(--concentric-radius-outer-md)',
    concentricRadiusOuterLg: 'var(--concentric-radius-outer-lg)',
    concentricRadiusInnerSm: 'var(--concentric-radius-inner-sm)',
} as const;
